import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IReportRequest, IReportResponse } from '../models/models'

export class GetOrderReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/returnReport/ReturnReports',
      requesterInfo,
    })
  }

  public async getReport(req: IReportRequest): Promise<IReportResponse[]> {
    return await this.postAsync<IReportResponse[]>(req)
  }
}
